import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Text,
  Spinner,
  Alert,
  AlertIcon,
  Grid,
  GridItem,
  Button,
  VStack,
  HStack,
  Avatar,
  Badge,
  useToast,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../Globalapi/Globalapi";



const ClassStudentsList = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const toast = useToast(); // Use Chakra's toast for notifications

  // Fetch Class Students Function
  const fetchClassStudents = async () => {
    try {
      const user_id = sessionStorage.getItem("user_id");
      if (!user_id) {
        setError("No user ID found.");
        setLoading(false);
        return;
      }
      const response = await axios.post(
        `${BASE_URL}/staff/class/class_students.php `,
        { pass: user_id },
        { headers: { "Content-Type": "application/json" } }
      );
      console.log("class_students", response);

      if (response.data.success) {
        setStudents(response.data.data);
      } else {
        setError(response.data.message);
      }
    } catch (err) {
      console.error("API call error:", err);
      setError("An error occurred while fetching data.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch data on mount
  useEffect(() => {
    fetchClassStudents();
  }, []);

  // Assign class leader function
  const assignClassLeader = async (classDetailsId, studentId) => {
    try {
      const user_id = sessionStorage.getItem("user_id");
      const response = await axios.put(
        `${BASE_URL}/staff/class/create_class_leader.php`,
        {
          pass: user_id,
          class_details_id: classDetailsId,
          student_id: studentId,
        },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.success) {
        toast({
          title: "Class leader assigned successfully",
          status: "success",
          duration: 3000,
        });
        await fetchClassStudents();
        window.location.reload();
      } else {
        toast({
          title: "Failed to assign class leader",
          status: "error",
          duration: 3000,
        });
      }
    } catch (error) {
      console.error("Error assigning class leader:", error);
      toast({
        title: "Error assigning class leader",
        status: "error",
        duration: 3000,
      });
    }
  };

  // Remove class leader function
  const removeClassLeader = async (classDetailsId) => {
    try {
      const user_id = sessionStorage.getItem("user_id");
      const response = await axios.put(
        `${BASE_URL}/staff/class/remove_class_leader.php`,
        { pass: user_id, class_details_id: classDetailsId },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.success) {
        toast({
          title: "Class leader removed successfully",
          status: "success",
          duration: 3000,
        });
        await fetchClassStudents();
      } else {
        toast({
          title: "Failed to remove class leader",
          status: "error",
          duration: 3000,
        });
      }
    } catch (error) {
      console.error("Error removing class leader:", error);
      toast({
        title: "Error removing class leader",
        status: "error",
        duration: 3000,
      });
    }
  };

  // Function to handle calling the guardian
  const handleCallGuardian = (guardianMobile) => {
    if (guardianMobile) {
      window.open(`tel:${guardianMobile}`);
    } else {
      toast({
        title: "Guardian mobile number not available",
        status: "warning",
        duration: 3000,
      });
    }
  };

  // Function to handle emailing the guardian
  const handleEmailGuardian = (guardianEmail) => {
    if (guardianEmail) {
      window.open(`mailto:${guardianEmail}`);
    } else {
      toast({
        title: "Guardian email address not available",
        status: "warning",
        duration: 3000,
      });
    }
  };

  if (loading) {
    return (
      <Box textAlign="center" py={10}>
        <Spinner size="xl" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={5}>
        <Alert status="error">
          <AlertIcon />
          {error}
        </Alert>
      </Box>
    );
  }

  return (
    <Box  width="100%">
      <Grid templateColumns="repeat(auto-fill, minmax(300px, 1fr))" gap={6}>
        {students.length > 0 ? (
          students.map((student) => (
            <GridItem
              key={student.student_id}
              bg="white"
              p={5}
              shadow="md"
              borderRadius="md"
            >
              <VStack align="start">
                {/* Student Header */}
                <HStack justifyContent="space-between" w="full">
                  <Text fontSize="sm" color="blue.500" fontWeight="bold">
                    {student.admission_number}
                  </Text>
                  <Badge
                    borderRadius="full"
                    fontSize="11px"
                    colorScheme={student.is_active ? "green" : "green"}
                  >
                    {student.is_active ? "Active" : "Active"}
                  </Badge>
                </HStack>

                {/* Student Profile */}
                <HStack w="full" alignItems="center">
                  <Avatar
                    name={student.student_name}
                    src={student.image_url}
                    size="md"
                  />
                  <VStack align="start">
                    <Link
                      to={`/students/detail/${student.student_user_id}`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <Text>{student.student_name}</Text>
                    </Link>
                    <Text fontSize="sm">{student.class_name}</Text>
                  </VStack>
                </HStack>

                {/* Student Details */}
                <HStack w="full" justifyContent="space-between">
                  <VStack align="start">
                    <Text fontSize="sm">Guardian</Text>
                    <Text fontWeight="bold">{student.guardian_name}</Text>
                  </VStack>
                  <VStack align="start">
                    <Text fontSize="sm">Gender</Text>
                    <Text fontWeight="bold">{student.gender}</Text>
                  </VStack>
                  <VStack align="start">
                    <Text fontSize="sm">DOB</Text>
                    <Text fontWeight="bold">{student.date_of_birth}</Text>
                  </VStack>
                </HStack>

                {/* Actions */}
                <HStack spacing={4} w="full" justifyContent="center" mt={4}>
                  <Button
                    colorScheme="green"
                    size="sm"
                    leftIcon={<i className="fas fa-phone-alt"></i>}
                    onClick={() => handleCallGuardian(student.guardian_mobile)}
                  >
                    Call
                  </Button>
                  <Button
                    colorScheme="blue"
                    size="sm"
                    leftIcon={<i className="fas fa-envelope"></i>}
                    onClick={() => handleEmailGuardian(student.guardian_email)}
                  >
                    Email
                  </Button>
                  <Button colorScheme="gray" size="sm">
                    Add Fees
                  </Button>
                </HStack>

                {/* Assign/Remove Leader */}
                <Box w="full" mt={4}>
                  {student.is_class_leader ? (
                    <Button
                      colorScheme="red"
                      onClick={() =>
                        removeClassLeader(student.class_details_id)
                      }
                      width="full"
                    >
                      Remove Leader
                    </Button>
                  ) : (
                    <Button
                      colorScheme="green"
                      onClick={() =>
                        assignClassLeader(
                          student.class_details_id,
                          student.student_id
                        )
                      }
                      width="full"
                    >
                      Assign as Leader
                    </Button>
                  )}
                </Box>
              </VStack>
            </GridItem>
          ))
        ) : (
          <Text>No students found for this class.</Text>
        )}
      </Grid>
    </Box>
  );
};

export default ClassStudentsList;
